<style src='@/resources/styles/results.css' scoped></style>
<style src='@/resources/styles/meme.css' scoped></style>

<template>
  <div class='word-block' :class='computedCls'
       :id="'word_' + output.id" ref="root">
      <div class='result'>
        <div class='head'>
          <!--
          <button class='more-menu-button'>
            <span class='more-menu-icon'></span>
          </button>
          -->
          <div class='word' v-if="! output.gif">
            {{output.result}}

            <!-- edit icon, hide for now
            <span style="color: white; font-size: medium; cursor: pointer">
              🖍️
            </span>-->

              <span v-if="output.batch_id > 1" style="font-size: small; color: goldenrod">
                  Batch {{output.batch_id}}
              </span>
          </div>


          <div class='word gif' v-if="output.gif">
          </div>



        </div>
        <div class='body' v-if="! output.gif">
          <transition appear enter-active-class="">
            <div class='feedback'>
            <div class='option'>
              <button class='response'
                      v-bind:class="{ on: isLiked}"
                      title="See more words like this"
                      v-on:click="like">
                <span class='icon simple-smile'></span>
                <span class='caption'><strong>Like</strong></span>
              </button>
            </div>

            <div class='option'>
              <button class='response'
                      v-bind:class="{ on: isLoved}"
                      title="See more words like this"
                      v-on:click="love">
                <span class='icon grin-hearts'></span>
                <span class='caption'>Love</span>
              </button>
            </div>

            <div class='option'>
              <button class='response'
                      v-bind:class="{ on: isDisliked}"
                      title="See fewer words like this"
                      v-on:click="nah">
                <span class='icon thumbs-down'></span>
                <span class='caption'>Hate</span>
              </button>
            </div>

          </div>
          </transition>
        </div>

        <div class='foot' v-if="! output.gif">
          <div class='purchase'>
            <div class='option'>
              <div class='available' :class="{
                check: isChecking(currentTld),
                true: isAvailable(currentTld),
                false: isUnAvailable(currentTld),
                premium: isPremium(currentTld),
                unknown: isUnknown(currentTld)
              }">

                <button class='dropdown-button select-domain' v-if="! isChecking(currentTld) && ! isUnknown(currentTld)">
                  <span class='dropdown-button-caption'>.{{currentTld.toLowerCase()}}</span>
                  <div class='dropdown-button-items'>
                    <span class='dropdown-button-item' v-for="tld in allTlds"  v-on:click="buy(tld)">
                      <i class='available' :class="{
                        check: isChecking(tld),
                        true: isAvailable(tld),
                        false: isUnAvailable(tld),
                        premium: isPremium(tld),
                        unknown: isUnknown(tld),

                      }" />
                      <span class='dropdown-button-label'>.{{tld.toLowerCase()}}</span>
                      <span class='dropdown-button-state' v-if="! canBuy(tld)">&nbsp;{{tldStatus(tld)}}</span>
                      <button class='buy' v-if="canBuy(tld)">Buy</button>
                    </span>
                  </div>
                </button>

                <span class="label">{{currentTldStatus}}</span>

              </div>
            </div>
            <div class='option'>
              <button class='buy' title="Buy this domain"
                      v-if="canBuy(currentTld)"
                      v-on:click="buy(currentTld)">
                <span class='caption'>Buy</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    <InfiniteScroll text="" v-bind:is-busy="isBusy" v-bind:loader="onScroll"
     v-if="! output.gif"/>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import DomainStatus from '../../DomainStatus'
  import TLD from "../../TLD";
  import Vote from "../../Vote";
  import InfiniteScroll from "../extended/InfiniteScroll";

  export default {
    name: 'Result',
    props: {
      output: Object,
      cls: String,
    },
    components: {
      InfiniteScroll,
    },

    mounted()
    {
      if (this.output.gif) {
        this.$refs.root.style.backgroundImage = `url("${this.output.result}")`
        window.console.log("Set url");
      }
    },

    data: function() {
      return {
        isBusy: false
      }
    },

    computed: {
      ...mapGetters(['filters', 'ws', 'domainStatus']),

      computedCls: function(){
        const blur = (this.isDisliked) ? " blur" : "";
        const meme = (this.output.gif) ? " meme" : "";
        return this.cls  + blur + meme ;
      },

      allTlds() {
        return TLD;
      },

      currentTld() {
        if (this.isAvailable(TLD.COM))
          return TLD.COM;

        if (this.isAvailable(TLD.NET))
          return TLD.NET;

        if (this.isAvailable(TLD.IO))
          return TLD.IO;

        return TLD.COM;
      },

      currentTldStatus() {
        return this.tldStatus( this.currentTld );
      },

      tldStatus() {
        const that = this;
        return (tld) => {
          const status = that.domainStatus(this.output.id, tld);
          switch (status)
          {
            case DomainStatus.CHECKING:
              return "Checking";

            case DomainStatus.NOT_AVAILABLE:
              return "Unavailable";

            case DomainStatus.AVAILABLE:
              return "Available!";

            case DomainStatus.PREMIUM:
              return "For Sale";

            case DomainStatus.UNKNOWN:
              return "Error";

            default:
              return status;
          }
        }
      },

      isChecking() {
        return (tld) => this.domainStatus(this.output.id, tld) === DomainStatus.CHECKING;
      },

      isAvailable() {
        return  (tld) => this.domainStatus(this.output.id, tld) === DomainStatus.AVAILABLE;
      },

      isUnAvailable() {
        return  (tld) => this.domainStatus(this.output.id, tld) === DomainStatus.NOT_AVAILABLE;
      },

      isPremium() {
        return  (tld) => this.domainStatus(this.output.id, tld) === DomainStatus.PREMIUM;
      },

      isUnknown() {
        return  (tld) => this.domainStatus(this.output.id, tld) === DomainStatus.UNKNOWN;
      },

      canBuy() {
        return  (tld) => this.isAvailable(tld) || this.isPremium(tld)
      },

      isLiked() {
        const vote = this.output.vote;
        return (vote === Vote.LIKED);
      },

      isLoved() {
        const vote = this.output.vote;
        return (vote === Vote.LOVED);
      },

      isDisliked() {
        const vote = this.output.vote;
        return (vote === Vote.DISLIKED);
      },
    },

    methods: {
      ...mapMutations(['setSimilar', 'setPage']),
      ...mapActions(['filter']),

      buy(tld) {
        if (! this.canBuy(tld))
          return;

        const domain = this.output.result + "." + tld.toLowerCase();
        //const url = `https://www.namecheap.com/domains/registration/results.aspx?domain=${domain}`;
          const url =
                      `https://namecheap.pxf.io/c/1928520/386170/5618?u=https%3A%2F%2Fwww.namecheap.com%2Fdomains%2Fregistration%2Fresults.aspx%3Fdomain%3D${domain}`;
        window.open(url, "_blank");
      },
      vote(newVote) {

        this.$emit("vote", newVote, this.output)
      },

      like() {
        this.vote(Vote.LIKED);
      },

      love() {
        this.vote(Vote.LOVED);
      },

      nah() {
        this.vote(Vote.DISLIKED);
      },

      onScroll() {
        this.isBusy = true;
        this.ws.socketPromise.then(socket => socket.markSeen( this.output.id ));
      },
    },
  }
</script>
